import { computed } from 'vue'
import type { CommuneDto } from '@/features/api/extranet/dto/Lov'

export type CodePostalCommuneValue = { code: string | null; commune: string | null }
export type UseCodePostalCommuneOptions = {
  getCodePostal: () => string | null | undefined
  getCommune: () => string | null | undefined
  updateValues: (values: CodePostalCommuneValue) => void
}
export function useCodePostalCommune(options: UseCodePostalCommuneOptions) {
  const { getCodePostal, getCommune, updateValues } = options
  const codePostalModel = computed({
    get() {
      return {
        code: '',
        codeInsee: '',
        intitule: getCodePostal(),
      } as CommuneDto
    },
    set(value: CommuneDto) {
      if (value.codeInsee) {
        updateValues({ code: value.code, commune: value.intitule })
      } else {
        updateValues({ code: value.intitule, commune: null })
      }
    },
  })

  const communeModel = computed<CommuneDto>({
    get() {
      return {
        code: '',
        codeInsee: '',
        intitule: getCommune(),
      } as CommuneDto
    },
    set(value) {
      if (value.codeInsee) {
        updateValues({ code: value.code, commune: value.intitule })
      } else {
        updateValues({ commune: value.intitule, code: null })
      }
    },
  })

  const getCpCommuneLabel = function (value: CommuneDto) {
    return `${value.code} ${value.intitule}`
  }

  return {
    codePostalModel,
    communeModel,
    getCpCommuneLabel,
  }
}
